import { render, staticRenderFns } from "./LazyPicture.vue?vue&type=template&id=565de02c&scoped=true&"
import script from "./LazyPicture.vue?vue&type=script&lang=js&"
export * from "./LazyPicture.vue?vue&type=script&lang=js&"
import style0 from "./LazyPicture.vue?vue&type=style&index=0&id=565de02c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565de02c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('565de02c')) {
      api.createRecord('565de02c', component.options)
    } else {
      api.reload('565de02c', component.options)
    }
    module.hot.accept("./LazyPicture.vue?vue&type=template&id=565de02c&scoped=true&", function () {
      api.rerender('565de02c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LazyPicture.vue"
export default component.exports